import { render, staticRenderFns } from "./PaymentCheckout.vue?vue&type=template&id=13dbd901"
import script from "../../controllers/payment/payment-checkout.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment/payment-checkout.js?vue&type=script&lang=js&external"
import style0 from "./PaymentCheckout.vue?vue&type=style&index=0&id=13dbd901&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports